export default __webpack_public_path__ + "media/src/assets/images/DOT_hazmat_class_8-d7edbfbc263f602054cb621b15bd777b.svg";